import * as React from 'react';

import { IBuilder } from '../../../../types/newbuildingHeader';
import { DataItem } from '../DataItem';

interface IDeveloperProps {
  developer: IBuilder;
}

export const Developer: React.FC<IDeveloperProps> = ({ developer }) => {
  return <DataItem image={developer.logoUrl} header="Застройщик" text={developer.name} />;
};
